import React, { useState } from 'react';
import QRCode from 'qrcode';

const PdfButton = ({ 
  onClick, 
  loading = false, 
  disabled = false,
  size = 'small',
  title = 'Generate PDF Evidence',
  showQRPreview = false,
  qrData = null,
  children,
  ...props 
}) => {
  const [qrCodeDataURL, setQrCodeDataURL] = useState(null);
  const [showQR, setShowQR] = useState(false);

  // Generate QR code preview when showQRPreview is true and qrData is provided
  React.useEffect(() => {
    if (showQRPreview && qrData && !qrCodeDataURL) {
      QRCode.toDataURL(qrData, {
        width: 100,
        margin: 1,
        color: {
          dark: '#000000',
          light: '#FFFFFF'
        }
      }).then(dataURL => {
        setQrCodeDataURL(dataURL);
      }).catch(error => {
        console.error('Error generating QR preview:', error);
      });
    }
  }, [showQRPreview, qrData, qrCodeDataURL]);
  const getButtonStyles = () => {
    const baseStyles = {
      backgroundColor: '#dc3545',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: loading || disabled ? 'not-allowed' : 'pointer',
      fontWeight: 500,
      transition: 'background-color 0.2s',
      opacity: loading || disabled ? 0.6 : 1,
    };

    switch (size) {
      case 'small':
        return {
          ...baseStyles,
          fontSize: '10px',
          padding: '4px 8px',
          width: '50px',
          minWidth: '50px'
        };
      case 'medium':
        return {
          ...baseStyles,
          fontSize: '12px',
          padding: '6px 12px',
          width: '60px',
          minWidth: '60px'
        };
      case 'large':
        return {
          ...baseStyles,
          fontSize: '14px',
          padding: '8px 16px',
          width: '80px',
          minWidth: '80px'
        };
      default:
        return baseStyles;
    }
  };

  const getButtonText = () => {
    if (children) return children;
    return loading ? 'Generating...' : 'PDF';
  };

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={onClick}
        disabled={loading || disabled}
        style={getButtonStyles()}
        title={title}
        onMouseEnter={() => showQRPreview && setShowQR(true)}
        onMouseLeave={() => showQRPreview && setShowQR(false)}
        {...props}
      >
        {getButtonText()}
      </button>
      
      {/* QR Code Preview Tooltip */}
      {showQRPreview && showQR && qrCodeDataURL && (
        <div style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'white',
          border: '1px solid #ccc',
          borderRadius: '4px',
          padding: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
          zIndex: 1000,
          marginBottom: '5px',
          textAlign: 'center',
          minWidth: '120px'
        }}>
          <img 
            src={qrCodeDataURL} 
            alt="QR Code Preview" 
            style={{ 
              width: '80px', 
              height: '80px',
              display: 'block',
              margin: '0 auto 4px auto'
            }} 
          />
          <div style={{ 
            fontSize: '10px', 
            color: '#666',
            lineHeight: '1.2'
          }}>
            Scan to open in Google Maps
          </div>
        </div>
      )}
    </div>
  );
};

export default PdfButton;
